import * as React from 'react';

import Instance from './Instance';


var Instances = function Instances(_ref) {
    var _ref$isCascadingPolic = _ref.isCascadingPolicyApplicable,
        isCascadingPolicyApplicable = _ref$isCascadingPolic === undefined ? false : _ref$isCascadingPolic,
        _ref$editors = _ref.editors,
        editors = _ref$editors === undefined ? [] : _ref$editors,
        onModification = _ref.onModification,
        onRemove = _ref.onRemove,
        onSave = _ref.onSave;
    return editors.map(function (_ref2) {
        var _ref2$isDirty = _ref2.isDirty,
            isDirty = _ref2$isDirty === undefined ? false : _ref2$isDirty,
            instance = _ref2.instance,
            _ref2$hasError = _ref2.hasError,
            hasError = _ref2$hasError === undefined ? false : _ref2$hasError,
            template = _ref2.template;
        return React.createElement(Instance, {
            canEdit: instance.canEdit,
            cascadePolicy: instance.cascadePolicy,
            data: instance.data,
            hasError: hasError,
            id: instance.id,
            isCascadingPolicyApplicable: isCascadingPolicyApplicable,
            isDirty: isDirty,
            isOpen: editors.length === 1,
            key: instance.id + '-' + template.templateKey,
            onModification: onModification,
            onSave: onSave,
            onRemove: onRemove,
            template: template
        });
    });
};

Instances.propTypes = {
    editors: PropTypes.arrayOf(function () {
        return (typeof bpfrpt_proptype_Editor === 'function' ? bpfrpt_proptype_Editor : PropTypes.shape(bpfrpt_proptype_Editor)).apply(this, arguments);
    }),
    isCascadingPolicyApplicable: PropTypes.bool,
    onModification: PropTypes.func,
    onRemove: PropTypes.func,
    onSave: PropTypes.func
};
export default Instances;
import { bpfrpt_proptype_Editor } from './flowTypes';
import { bpfrpt_proptype_JSONPatchOperations } from './flowTypes';
import { bpfrpt_proptype_CascadingPolicyData } from './flowTypes';
import PropTypes from 'prop-types';